export default "__VITE_ASSET__D3Yu55NT__"